import React from 'react';

interface ContextCardButtonProps {
    card: {
        id: string;
        emoji: string;
        title: string;
    };
    onClick: (cardId: string, prompt: string) => void;
    prompt: string;
    isLoading: boolean;
    isClicked: boolean;
    variant: 'minimized' | 'full';
}

const ContextCardButton: React.FC<ContextCardButtonProps> = ({
    card,
    onClick,
    prompt,
    isLoading,
    isClicked,
    variant
}) => {
    const baseClasses = "text-gray-800 rounded-2xl text-left transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed";
    const stateClasses = isClicked ? 'opacity-100' : 'bg-gradient-to-r from-blue-100 via-purple-200 to-pink-200 hover:from-blue-200 hover:via-purple-300 hover:to-pink-300';

    if (variant === 'minimized') {
        return (
            <button
                onClick={() => onClick(card.id, prompt)}
                disabled={isLoading}
                className={`${baseClasses} flex items-center space-x-3 group px-3 py-2 flex-shrink-0 min-w-0 ${stateClasses}`}
            >
                <div className="flex items-center justify-center flex-shrink-0 text-green-600 group-hover:text-green-700 w-5 h-5">
                    <span className="text-lg">{card.emoji}</span>
                </div>
                <div className="min-w-0 flex-1 flex items-center justify-center ">
                    <span className="font-medium whitespace-pre-line text-sm">{card.title}</span>
                </div>
            </button>
        );
    }

    return (
        <button
            onClick={() => onClick(card.id, prompt)}
            disabled={isLoading}
            className={`${baseClasses} flex items-center space-x-3 group px-4 py-3 h-full ${stateClasses}`}
        >
            <div className="flex items-center justify-center flex-shrink-0 text-green-600 group-hover:text-green-700 w-8 h-8">
                <span className="text-2xl">{card.emoji}</span>
            </div>
            <div className="min-w-0 flex-1">
                <span className="font-medium whitespace-pre-line text-sm">{card.title}</span>
            </div>
        </button>
    );
};

export default ContextCardButton;
